export default __webpack_public_path__ + "207a81c.png";